import { ICalendarResourcesHook } from '@models';
import { useStore } from '@stores';
import { useEffect, useMemo } from 'react';

interface IProps {
  userId?: number;
  activeView?: 'TechnicianView' | 'WorkStationView';
  technicianOnly?: boolean;
}

export const useCalendarResources = ({
  userId,
  activeView = 'TechnicianView',
  technicianOnly = false,
}: IProps): ICalendarResourcesHook => {
  const { userStore, tenantProfileStore } = useStore();
  const { tenantProfileWorkStations, loading: workStationLoading } = tenantProfileStore;
  const { calendarUsers, loading } = userStore;

  useEffect(() => {
    return () => {
      userStore.clearCalendarUsers();
      tenantProfileStore.clearTenantProfileWorkStations();
    };
  }, [userStore, tenantProfileStore]);

  useEffect(() => {
    if (activeView === 'WorkStationView') {
      tenantProfileStore.getAllWorkStations({ skipCount: 0, maxResultCount: 50 });
    }
    if (activeView === 'TechnicianView') {
      userStore.getCalendarAll({
        userId,
        technicianOnly,
        skipCount: 0,
        maxResultCount: 50,
      });
    }
  }, [userStore, userId, technicianOnly, activeView]);

  const userArray = Array.from(calendarUsers.values());

  const technicianResources: any[] = useMemo(
    () =>
      userArray.map((user) => {
        return { id: user.id?.toString(), title: user.fullname, orderPosition: user.fullname };
      }),
    [userArray]
  );

  const workStationResources: any[] = useMemo(
    () =>
      tenantProfileWorkStations.map((workStation) => {
        return {
          id: workStation.id,
          title: workStation.name,
          orderPosition: workStation.orderPosition,
        };
      }),
    [tenantProfileWorkStations]
  );

  return {
    loading: loading || workStationLoading,
    resources: activeView === 'WorkStationView' ? workStationResources : technicianResources,
  };
};
